<template>
  <SNavHeader :links="links" :title="`${user.firstName} ${user.lastName}`" size="md" class="mb-3">
    <template #actions>
      <s-btn
        v-if="page.props.loggedInUser.isSuperUser"
        color="secondary"
        icon="account-switch"
        :href="route('admin.act-as.show', {email: user.email})"
      >
        {{ t('actions.act-as') }}
      </s-btn>
      <s-btn
        v-if="page.props.loggedInUser.isSuperUser"
        color="blue-light"
        icon="pencil"
        :href="route('admin.users.edit', user.id)"
      >
        {{ t('actions.edit') }}
      </s-btn>
    </template>
  </SNavHeader>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js';
import SBtn from '../design-system/SBtn.vue';
import SNavHeader from '../design-system/SNavHeader.vue';
import {User} from '../types/entities/user';
import {useI18n} from 'vue-i18n';
import {computed} from 'vue';
import {usePage} from '@inertiajs/vue3';

const page = usePage<{
  loggedInUser: {
    isSuperUser: boolean;
  };
}>();
const {user} = defineProps<{
  user: User;
}>();

const {t} = useI18n({
  useScope: 'local',
  inheritLocale: true,
});

const links = computed(() =>
  [
    {
      label: 'General',
      icon: 'account',
      href: route('admin.users.show', {user: user.id}),
      authorized: true,
    },
    {
      label: 'Activity Log',
      icon: 'calendar-text-outline',
      href: route('admin.users.activity.index', {user: user.id}),
      authorized: page.props.loggedInUser.isSuperUser,
    },
    {
      label: 'System Roles',
      icon: 'account-key',
      href: route('admin.users.roles.index', {user: user.id}),
      authorized: page.props.loggedInUser.isSuperUser,
    },
    {
      label: 'Features',
      icon: 'ab-testing',
      href: route('admin.users.features.index', {user: user.id}),
      authorized: page.props.loggedInUser.isSuperUser,
    },
  ].filter((link) => link.authorized)
);
</script>
<style scoped></style>
